import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material';
import React from 'react';
// import { Checkbox, Radio, Fab, InputAdornment, MenuItem, Switch } from '@mui/material';
import toast from 'react-hot-toast';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import _ from 'lodash';
import * as Yup from 'yup';
import { transformYupErrorsIntoArray } from '../../../utils/fn';
import { loginSafalMyBuyUser, connectSafalMyBuyUser, getSafalMyBuyUserInfo } from '../../../services/Service';
import YourImage from '../../../assets/UserAvtarBackground.png';
import { setSafalMyBuyState } from '../../../store/SafalMyBuySlice';

const validationSchema = Yup.object().shape({
  username: Yup.string().required('required'),
  password: Yup.string().required('required'),
});

const resetFieldValue = {
  username: '',
  password: '',
};

const ConnectToSafalMyBuy = ({ onClose, open }) => {
  const [fieldValue, setFieldValue] = React.useState({ ...resetFieldValue });
  const [fieldValueError, setFieldValueError] = React.useState([]);
  const [isDisableAll, setIsDisableAll] = React.useState(false);
  const [loginData, setLoginData] = React.useState(null);
  const dispatch = useDispatch();

  const onCloseThis = (refetchFlag) => {
    setIsDisableAll(false);
    setLoginData(null);
    setFieldValue({ ...resetFieldValue });
    setFieldValueError([]);
    onClose(refetchFlag);
  };
  const handleClose = async (refetchFlag) => {
    onCloseThis(refetchFlag);
  };

  const onSubmit = async () => {
    setIsDisableAll(true);
    setFieldValueError([]);
    try {
      await validationSchema.validate(fieldValue, { abortEarly: false, strict: false });
      const res = await loginSafalMyBuyUser(fieldValue);
      if (res.status === 200) {
        toast.success('Login Successful');
        setLoginData(res.data?.data);
      }
    } catch (err) {
      setFieldValueError(transformYupErrorsIntoArray(err));
      toast.error(err?.response?.data?.message || err.message);
    } finally {
      setIsDisableAll(false);
    }
  };

  const onSubmitConnect = async () => {
    setIsDisableAll(true);
    setFieldValueError([]);
    try {
      const res = await connectSafalMyBuyUser({ safalMyBuyUserId: loginData.id });
      if (res.status === 200) {
        // SafalMyBuy info load
        getSafalMyBuyUserInfo().then((resX) => {
          const res_data = resX?.data?.data;
          if (res_data) {
            dispatch(setSafalMyBuyState(res_data));
          }
        });
        toast.success('Connect to SafalMyBuy Successful');
        handleClose(true);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    } finally {
      setIsDisableAll(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={(_e, reason) => {
        if (reason && reason === 'backdropClick') return;
        handleClose();
      }}
      PaperProps={{
        sx: {
          height: '400px',
        },
      }}
    >
      {loginData ? (
        <DialogTitle style={{ color: '#ec864c' }}>Connect to SafalMyBuy</DialogTitle>
      ) : (
        <DialogTitle style={{ color: '#ec864c', display: 'flex', justifyContent: 'center' }}>
          <img
            style={{ width: '150px', objectFit: 'contain' }}
            src="/assets/images/safalmybuy_logo_full.png"
            alt="safalmybuy_logo"
          />
        </DialogTitle>
      )}
      <DialogContent
        style={{
          width: '450px',
        }}
      >
        {/* {!loginData && (
          <DialogContentText style={{ marginBottom: '16px' }}>
            To connect your account to SafalMyBuy, please enter your SafalMyBuy username and password here.
          </DialogContentText>
        )} */}
        {loginData ? (
          <div
            style={{ display: 'flex', flexDirection: 'column', gap: '6px', alignItems: 'center', marginTop: '32px' }}
          >
            <img
              src={loginData?.profileImage ? loginData?.profileImage : YourImage}
              style={{ width: '100px', height: '100px', objectFit: 'contain', borderRadius: '999px' }}
              alt={`${loginData?.firstName} ${loginData?.lastName}`}
            />
            <span style={{ fontSize: '20px', fontWeight: 'bold' }}>
              {loginData?.firstName} {loginData?.lastName}
            </span>
            {/* <span style={{ fontSize: '16px' }}>
                Username: <i>{loginData?.username}</i>
              </span> */}
            <span style={{ fontSize: '16px' }}>{loginData?.email}</span>
          </div>
        ) : (
          <>
            <TextField
              style={{ marginTop: '16px' }}
              disabled={isDisableAll}
              value={fieldValue.username}
              onChange={(e) => setFieldValue({ ...fieldValue, username: e.target.value })}
              label={
                <Typography sx={{ color: '#B6B6B6' }}>
                  Username <span style={{ color: 'red' }}>*</span>
                </Typography>
              }
              size="small"
              type="text"
              placeholder="Enter your SafalMyBuy username"
              fullWidth
              variant="outlined"
              InputLabelProps={{
                style: { color: 'black' },
                shrink: true,
              }}
              error={fieldValueError?.find((e) => e.key === 'username')}
              helperText={fieldValueError?.find((e) => e.key === 'username')?.error}
              inputProps={{
                maxlength: 100,
              }}
            />
            <TextField
              disabled={isDisableAll}
              value={fieldValue.password}
              onChange={(e) => setFieldValue({ ...fieldValue, password: e.target.value })}
              label={
                <Typography sx={{ color: '#B6B6B6' }}>
                  Password <span style={{ color: 'red' }}>*</span>
                </Typography>
              }
              size="small"
              placeholder="Enter your SafalMyBuy password"
              type="password"
              fullWidth
              variant="outlined"
              InputLabelProps={{
                style: { color: 'black' },
                shrink: true,
              }}
              style={{ marginTop: '16px' }}
              error={fieldValueError?.find((e) => e.key === 'password')}
              helperText={fieldValueError?.find((e) => e.key === 'password')?.error}
              inputProps={{
                maxlength: 100,
              }}
            />
          </>
        )}
        {loginData?.safalSubscriptionUserId && (
          <DialogContentText color={'#ff4842'} style={{ marginTop: '16px', textAlign: 'center' }}>
            This SafalMyBuy account already connected with SafalSubscription account.
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          sx={{
            backgroundColor: '#ff4842',
            ':hover': { backgroundColor: '#d40700' },
            color: 'white',
            borderRadius: '30px',
            textTransform: 'capitalize',
            minWidth: '100px',
          }}
          variant="contained"
          disabled={isDisableAll}
          onClick={() => handleClose()}
        >
          Close
        </Button>
        {loginData && !loginData?.safalSubscriptionUserId && (
          <Button
            sx={{
              backgroundColor: '#ec864c',
              borderRadius: '30px',
              textTransform: 'capitalize',
              minWidth: '100px',
            }}
            variant="contained"
            disabled={isDisableAll}
            onClick={() => onSubmitConnect()}
          >
            Connect
          </Button>
        )}
        {!loginData && (
          <Button
            sx={{
              backgroundColor: '#ec864c',
              borderRadius: '30px',
              textTransform: 'capitalize',
              minWidth: '100px',
            }}
            variant="contained"
            disabled={isDisableAll}
            onClick={() => onSubmit()}
          >
            Login
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ConnectToSafalMyBuy;
